import FormTitle from '@core/components/FormTitle';
import { TextLabel } from '@core/components/Inputs';
import DateLabel from '@core/components/Inputs/DateLabel';
import { Grid, makeStyles, Table, TableCell, TableHead, TablePagination, TableRow } from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import contasPagarApi from 'app/services/api/contasPagarApi';
import { getCurrencySemSinalMonetario } from 'app/utils/monetarioUtil';
import moment from 'moment';
import React, { useEffect, useState } from 'react';

const useStyles = makeStyles({
  badgeCompraPaga: {
    backgroundColor: '#43a047',
    color: '#ffffff',
    margin: 0,
    marginLeft: 8,
    marginRight: 8,
    paddingLeft: 4,
    paddingRight: 4,
    paddingTop: 2,
    paddingBottom: 2,
    fontSize: 10,
    lineHeight: 0.8,
    fontWeight: 600,
    width: 24,
    height: 13,
  },
});

const formasPagamento = {
  CARTAO_CREDITO: 'Cartão de crédito',
  CARTAO_DEBITO: 'Cartão de débito',
  CHEQUE: 'Cheque',
  DEBITO_AUTOMATICO: 'Débito automático',
  DEBITO_CONTA: 'Débito em conta',
  DOC: 'DOC',
  TED: 'TED',
  TRANSFERENCIA_BANCARIA: 'Transferência bancária',
  DINHEIRO: 'Dinheiro',
  BOLETO: 'Boleto',
  PIX: 'Pix',
  OUTRAS: 'Outras',
};

const VisualizarCompraInformacoesPagamentoAVista = ({ values }) => {
  const [conta, setConta] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchConta = async () => {
      try {
        const contaData = await contasPagarApi.buscarPorId(values.contaPagarId);
        setConta(contaData);
      } catch (error) {
        console.error('Erro ao buscar conta:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchConta();
  }, [values.contaPagarId]);

  if (loading) {
    return <p>Carregando...</p>;
  }

  if (!conta) {
    return <p>Erro ao carregar os dados da conta.</p>;
  }

  return (
    <>
      <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
        <TextLabel id="condicaoAvista" label="Condição de pagamento" value="A vista" />
      </Grid>
      <Grid item xs={4} sm={4} md={4} lg={4} xl={4} alignContent="center" alignItems="center">
        <DateLabel
          id="dataVencimento"
          label="Data do vencimento"
          value={values?.dataVencimento ? moment(values.dataVencimento) : null}
        />
      </Grid>
      <Grid item xs={4} sm={4} md={4} lg={4} xl={4} alignItems="center" alignContent="center" className="mt-16">
        {conta?.data?.situacao === 'BAIXADA' && !!values?.dataPagamento && (
          <>
            <CheckIcon style={{ color: '#43a047' }} />
            <span>Compra paga</span>
          </>
        )}
      </Grid>
      {conta?.data?.situacao === 'BAIXADA' && !!values?.dataPagamento && (
        <>
          <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
            <DateLabel
              id="dataPagamento"
              label="Data do pagamento"
              value={values?.dataPagamento ? moment(values.dataPagamento) : null}
            />
          </Grid>
          <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
            <DateLabel
              id="dataLiquidacao"
              label="Data da liquidação"
              value={values?.dataLiquidacao ? moment(values.dataLiquidacao) : null}
            />
          </Grid>
          <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
            <TextLabel id="conta" label="Conta" value={values?.conta?.descricao} />
          </Grid>
          <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
            <TextLabel id="formaPagamento" label="Forma de pagamento" value={formasPagamento[values?.formaPagamento]} />
          </Grid>
          <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
            <TextLabel
              id="valorJuros"
              label="Juros (R$)"
              value={
                values?.valorJuros != null
                  ? Number(values.valorJuros).toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                    })
                  : ''
              }
            />
          </Grid>
          <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
            <TextLabel
              id="valorMulta"
              label="Multa (R$)"
              value={
                values?.valorMulta != null
                  ? Number(values.valorMulta).toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                    })
                  : ''
              }
            />
          </Grid>
          <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
            <TextLabel
              id="valorDesconto"
              label="Desconto (R$)"
              value={
                values?.valorDesconto != null
                  ? Number(values.valorDesconto).toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                    })
                  : ''
              }
            />
          </Grid>
          <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
            <TextLabel
              id="valorPago"
              label="Valor pago (R$)"
              value={
                values?.valorPago != null
                  ? Number(values.valorPago).toLocaleString('pt-BR', {
                      style: 'currency',
                      currency: 'BRL',
                    })
                  : ''
              }
            />
          </Grid>
          <Grid item xs={4} sm={4} md={4} lg={4} xl={4}>
            {values?.formaPagamento === 'CHEQUE' && (
              <TextLabel id="numeroCheque" label="Número do cheque" value={values?.numeroCheque} />
            )}
          </Grid>
        </>
      )}
    </>
  );
};
const VisualizarCompraInformacoesPagamentoParcelado = ({ values }) => {
  const [page, setPage] = useState(0);

  const styles = useStyles();

  const rowsPerPage = 5;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  return (
    <>
      <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
        <TextLabel id="condicaoParcelado" label="Condição de pagamento" value="Parcelado" />
      </Grid>
      <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
        <TextLabel id="quantidadeParcelas" label="Quantidade de parcelas" value={values?.length} />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12} xl={12} style={{ paddingBottom: 0 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell align="start">Parcela</TableCell>
              <TableCell align="center">Data do vencimento</TableCell>
              <TableCell align="right">Valor parcelado (R$)</TableCell>
            </TableRow>
          </TableHead>

          {values?.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)?.map((parcela, index) => (
            <TableRow>
              <TableCell component="th" align="start">
                {parcela?.contaBaixada ? (
                  <>
                    {`Parcela ${page * rowsPerPage + index + 1}`}
                    <span className={styles.badgeCompraPaga}>Pago</span>
                  </>
                ) : (
                  `Parcela ${page * rowsPerPage + index + 1}`
                )}
              </TableCell>
              <TableCell align="center">
                {parcela?.dataVencimento ? moment(parcela.dataVencimento).format('DD/MM/YYYY') : '-'}
              </TableCell>
              <TableCell align="right">{getCurrencySemSinalMonetario(parcela?.valorParcela)}</TableCell>
            </TableRow>
          ))}
        </Table>

        <TablePagination
          component="div"
          className="pb-0"
          count={values?.length}
          rowsPerPage={rowsPerPage}
          labelRowsPerPage={false}
          page={page}
          labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
          onChangePage={handleChangePage}
          rowsPerPageOptions={[]}
        />
      </Grid>
    </>
  );
};

const VisualizarCompraInformacoesPagamento = ({ values }) => {
  return (
    <>
      <div>
        <FormTitle title="Informações do pagamento" />
      </div>
      <Grid container spacing={3} className="mb-10">
        {values?.pagamento?.condicaoPagamento === 'A_VISTA' ? (
          <VisualizarCompraInformacoesPagamentoAVista values={values?.pagamento?.avista} />
        ) : (
          <VisualizarCompraInformacoesPagamentoParcelado values={values?.pagamento?.parcelado} />
        )}
      </Grid>
    </>
  );
};

export default VisualizarCompraInformacoesPagamento;
